/* eslint-disable no-unused-vars */
import {
  SET_SAVE_ALL,
  SET_SAVE_YEAR,
  SET_SAVE_NAME
} from '@/store/modules/bs_inf/mutations'

import ConfigApi from '../../../apis/config'

export const GET_DEMO = 'GET_DEMO'
export const SAVE_CATEGORY_ALL = 'SAVE_CATEGORY_ALL'
export const SAVE_CATEGORY_YEAR = 'SAVE_CATEGORY_YEAR'
export const SAVE_CATEGORY_NAME = 'SAVE_CATEGORY_NAME'

export default {
  [GET_DEMO]({ commit }) {
    return ConfigApi.getTestAxios()
  },

  [SAVE_CATEGORY_ALL]({ commit }, data) {
    commit(SET_SAVE_ALL, data)
  },
  [SAVE_CATEGORY_YEAR]({ commit }, data) {
    commit(SET_SAVE_YEAR, data)
  },
  [SAVE_CATEGORY_NAME]({ commit }, data) {
    commit(SET_SAVE_NAME, data)
  }

}